module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C1797"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "C1840"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "html/images/Image_6_0.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "C1771"
  }, [_c('a', {
    attrs: {
      "href": "#/html/05_Acknowle#page_9"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1786"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/06_1_Introd#page_11"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/06_1_Introd#page_11"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1780"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/06_1_Introd#id_3"
    }
  }, [_vm._v("Lo cunto de li cunti:")])]), _c('a', {
    attrs: {
      "href": "#/html/06_1_Introd#id_3"
    }
  }, [_vm._v(" A “Cinderella” of Literary History")])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_1_Introd#id_22"
    }
  }, [_vm._v("The Origins of the Literary Fairy Tale")])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_1_Introd#id_36"
    }
  }, [_vm._v("Defining the Literary Fairy Tale")])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_1_Introd#id_54"
    }
  }, [_vm._v("Fairy Tales and Reality")])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_1_Introd#id_78"
    }
  }, [_vm._v("The Editorial and Critical History of "), _c('em', [_vm._v("Lo cunto de li cunti ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1786"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/07_2_The_Li#page_35"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/07_2_The_Li#page_35"
    }
  }, [_vm._v("The Life and Times of Giambattista Basile")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1780"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_2_The_Li#id_102"
    }
  }, [_vm._v("The Kingdom of Naples")])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_2_The_Li#id_129"
    }
  }, [_vm._v("The Wandering Courtier")])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_2_The_Li#id_166"
    }
  }, [_vm._v("Intellectual Life: The Courts and Academies")])]), _vm._v(" "), _c('p', {
    staticClass: "C1786"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/08_3__The_C#page_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/08_3__The_C#id_199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cultural Background of")])]), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_3__The_C#id_199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Lo cunto deli cunti")]), _vm._v("). ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1780"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_3__The_C#id_200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Renaissance Novella to Baroque Fairy Tale")])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_3__The_C#id_250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Italian to Neapolitan")])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_3__The_C#id_298",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The "), _c('em', [_vm._v("Lettere ")]), _vm._v("and "), _c('em', [_vm._v("Le Muse napoletane ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1786"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/09_4__Rites#page_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/09_4__Rites#id_317",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rites of Initiation")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1780"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_4__Rites#id_318",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Frame Tale")])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_4__Rites#id_371",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rites of Passage (Tale I.1)")])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_4__Rites#id_379",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Narrative Organization of "), _c('em', [_vm._v("Lo cunto de li cunti ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1786"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/10_5__The_D#page_111",
      "id": "id_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/10_5__The_D#id_416",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Disenchantment of Power: Kings and Courtiers")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1780"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_5__The_D#id_420",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monarchic Misdoings: Kings")])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/10_5__The_D#id_432",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dangers of Idleness: Frivolous Kings")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/10_5__The_D#id_449",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Benefits of Counsel: Inept Kings")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/10_5__The_D#id_455",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Seduction of the Same: Incestuous Kings")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/10_5__The_D#id_462",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abandoned Brides: Forgetful Kings")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/10_5__The_D#id_473",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With a Vengeance: Cruel Kings")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_5__The_D#id_484",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Price of Success: Courtiers")])]), _vm._v(" "), _c('p', {
    staticClass: "C1786"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/11_6__The_K#page_155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/11_6__The_K#id_509",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Key to Success: Enterprising Heroes and Heroines")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1780"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_6__The_K#id_523",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Collaborating for Success")])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_6__The_K#id_529",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deception and Disguise: Winning through Trickery")])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_6__The_K#id_540",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Modeling Destinies: The Creation of Fairy-Tale Subjects")])]), _vm._v(" "), _c('p', {
    staticClass: "C1786"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/12_7__Signi#page_175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/12_7__Signi#id_558",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Significant Others: Ogres, Fools, and Forests")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1780"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_7__Signi#id_559",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figures of Alterity: Ogres")])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_7__Signi#id_597",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Praise of Folly: Triumphant Simpletons")])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_7__Signi#id_646",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fairy-Tale Landscapes: The Case of the "), _c('em', [_vm._v("Bosco ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1786"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/13_8__Marve#page_217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/13_8__Marve#id_670",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marvelous Metaphor")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1780"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_8__Marve#id_671",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baroque Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_8__Marve#id_685",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Magic of Metaphor")])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_8__Marve#id_695",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Metamorphosis of Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/13_8__Marve#id_700",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transfiguring Mythological Tradition")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/13_8__Marve#id_716",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Repainting the Renaissance Literary Portrait")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/13_8__Marve#id_736",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dawn of a New Day: Baroque Hybridity")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1786"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/14_9__Epilo#page_249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/14_9__Epilo#id_763",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: The Triumph of the Carnivalesque")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1779"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_Notes#page_257",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_Bibliogr#page_313",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1724"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_Index#page_323",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INDEX")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca3484f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_Contents.vue
// module id = 69
// module chunks = 0